import { JockeyName } from '@core/Areas/RaceCard/Components/JockeyName'
import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import { MatchedFieldSummaryResults } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummaryResults'
import type ObservableRaceFinisher from '../../../Model/Observables/ObservableRaceFinisher'
import type ObservableResultsPage from '../../../Model/Observables/ObservableResultsPage'
import BaseFinisherViewModel from '../BaseFinisherViewModel'

export interface Params {
  raceInformation: ObservableResultsPage
  finisher: ObservableRaceFinisher
  showField: boolean
}

export class RaceFinisherViewModel extends BaseFinisherViewModel {
  public MatchedFieldSummaryResults: typeof MatchedFieldSummaryResults
  public MatchedFieldSummary: typeof MatchedFieldSummary
  public JockeyName: typeof JockeyName

  constructor(params: Params) {
    super(params)
    this.MatchedFieldSummaryResults = MatchedFieldSummaryResults
    this.MatchedFieldSummary = MatchedFieldSummary
    this.JockeyName = JockeyName
  }
}
